$(window).resize(function() {
    if ($(window).width() >= 1170) {
        /*  wenn in der mobilen Ansicht der "Bestellung"-Tab aktiv ist und man wechselt auf die Desktop Variante, müssen die Kataloge wieder angezeigt werden */
        $(".ttgCatalogues").show();
        $('#ttgKatalogForm').show();
        $('.ttgCatalogues').show();
        $('.ttgKatalogeCategoryHeadline').show();
        $('.ttgKatalogSocialShare').show();
        $('.ttgKatalogeInfoPopUp').hide();
    }

    if ($(window).width() < 1170) {
        if ($(".ttgTabBestellungBtn ").hasClass("ttgTabActive")) {
            $(".ttgCatalogues").hide();
            $('#ttgKatalogForm').show();
            $('.ttgCatalogues').hide();
            $('.ttgKatalogeCategoryHeadline').hide();
            $('.ttgKatalogSocialShare').hide();
        }
    }
});

//Kataloge
if ($("#ttgKatalogForm .google-recaptcha").length) {
    $('#ttgKatalogForm .recaptcha-consent input[type="checkbox"]').on('change', function() {
        if ($(this).is(':checked')) {
            var sitekey = $("#ttgKatalogForm").find('.google-recaptcha').data('sitekey');
            var head = document.getElementsByTagName('head')[0];
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = 'https://www.google.com/recaptcha/api.js?onload=onloadCallbackKatalog&render=' + sitekey;
            script.setAttribute('defer', '');
            head.appendChild(script);
        }
    });
}

var onloadCallbackKatalog = function() {
    grecaptcha.ready(function() {
        grecaptcha.execute($("#ttgKatalogForm").find('.google-recaptcha').data('sitekey'), {
            action: 'submitKatalog'
        }).then(function(token) {
            $('#ttgKatalogForm input[type="hidden"][name="g-recaptcha-response"]').val(token);
        });
    });
};

/* PARSLEY */
$('#ttgKatalogForm').parsley();

/*  Stückmodus */
var stkMode = false;
if ($('#ttgKatalogForm').data('stkmode') == '1') {
    var stkMode = true;
}

var amountSelectedCatalogues = 0;

/*  Klick auf Auswahlcheckbox in der Liste */
$('.btnCatForm.addCat').click(function(e) {
    e.preventDefault();

    /*  Check (in der Liste) ob Katalog schon gewählt */
    if ($('#checked' + $(this).attr('id')).length) {
        /*  wenn der Katalog bereits hinzugefügt worden ist, den Katalog entfernen */
        $('#checked' + $(this).attr('id')).closest('.checkedCat').remove();
        amountSelectedCatalogues = amountSelectedCatalogues - 1;

        $(this).removeClass('disabled checked');
        $(this).removeAttr('disabled');

    } else {
        /*  wurde der Katalog noch nicht hinzugefügt, den Katalog hinzufügen */

        /*  wenn ein Dropdown für verschiedene Sprachversionen vorhanden ist, den aktuellen Wert via Data-Attribut übergeben */
        if ($(this).closest('.row').find('select').length) {
            $(this).attr('data-catLang', $(this).closest('.row').find('select').val());
        }

        if (stkMode) {
            var stk = 1;
            var stkSuffix = "<input type='text' class='stk ttgStueckInput' value='" + stk + "x' onChange=\"$(this).parent().parent().parent().attr('data-catStk',$(this).val().replace('x',''))\" /> ";
        } else {
            var stk = 1;
            var stkSuffix = stk + "x ";
        }

        $('<div class="checkedCat" data-catStk="' + stk + '" data-catTitle="' + $(this).attr('data-catTitle') + '" data-catCorrPattern="' + $(this).attr('data-catCorrPattern') + '" data-catLang="' + $(this).attr('data-catLang') + '" data-catID="' + $(this).attr('data-catID') + '" data-catCRM="' + $(this).attr('data-catCRM') + '" data-catDistributor="' + $(this).attr('data-catDistributor') + '"><div class="katalog"><div class="col-md-10 col-sm-10 col-xs-10 p-2">' + stkSuffix + $(this).attr('data-catTitle') + ' [' + $(this).attr('data-catLang') + ']</div><div class="col-md-2 col-sm-2 col-xs-2 text-right"><a href="javascript:removeCat(\'' + $(this).attr('id') + '\');" role="button" class="checkCat checked ttgRemoveCat" id="checked' + $(this).attr('id') + '"><span class="fa-solid fa-xmark" aria-hidden="true"></span><span class="sr-only">' + $('#ttgKatalogForm').data('loeschen') + '</span></a></div></div></div>').appendTo('div#catHolder' + $(this).attr('data-catPos'));
        $('h3.invalid').removeClass('invalid');
        $('div.ttgAuswahl .ttgCatHolder').removeAttr('aria-invalid').removeAttr('aria-describedby');
        $('#katalog-error .parsley-custom-error-message').text('');

        amountSelectedCatalogues = amountSelectedCatalogues + 1;

        $(this).addClass('disabled checked');
        $(this).attr("disabled", "disabled");
    }

    $('.ttgKatalogBestellungAmount').html('(' + amountSelectedCatalogues + ')');
});

/*  Check Field direkt nach Eingabe */
$('#ttgKatalogForm .required').blur(function() {
    checkField($(this).attr('id'));
});

/*  Check Form bei Submit */
$('#bestellen').click(function(e) {

    /*  Check Fields */
    $('#ttgKatalogForm .required').each(function(i) {
        checkField($(this).attr('id'));
    });

    /*  Check Kataloge */
    if ($('#ttgKatalogForm').find('.checkedCat').length) {
        $('h3.ttgAuswahl').removeClass('invalid');
        $('div.ttgAuswahl .ttgCatHolder').removeAttr('aria-invalid').removeAttr('aria-describedby');
        $('#katalog-error .parsley-custom-error-message').text('');
    } else {
        $('h3.ttgAuswahl').addClass('invalid');
        $('div.ttgAuswahl .ttgCatHolder').attr('aria-invalid', 'true').attr('aria-describedby', 'katalog-error');
        $('#katalog-error .parsley-custom-error-message').text($('#katalog-error').data('parsley'));
    }

    /*  Check ob Klasse invalid vorhanden >> ERROR */
    if ($('#ttgKatalogForm').find('.invalid').length) {
        /*  FEHLER IM FORMULAR */
        return false;
    } else {

        /*  FORMULAR KORREKT */

        /*  Befülle das Hidden-Field #kataloge mit den Werten */
        var kataloge = "";
        $('#ttgKatalogForm').find('.checkedCat').each(function(i) {
            kataloge = kataloge + $(this).attr('data-catID') + "||" + $(this).attr('data-catCRM') + "||" + $(this).attr('data-catDistributor') + "||" + $(this).attr('data-catStk') + "x " + $(this).attr('data-catTitle') + " [" + $(this).attr('data-catLang') + "]" + "||" + $(this).attr('data-catCorrPattern') + "###";
        });

        $('#ttgKatalogForm #kataloge').val(kataloge);

        /*  Leere noch vorhandene Standartwerte */
        $('#ttgKatalogForm input').each(function(i) {
            if ($(this).val() == $(this).attr('title')) {
                $(this).val('');
            }
        });

        /* den Button auf disabled setzen um 2x abzuschicken zu verhindern */
        setTimeout(() => {
            $('.ttgKatalogSubmitButton').attr('disabled', 'disabled');
        }, 50);

        e.preventDefault();

        /*  Formular absenden – vorher frisches reCAPTCHA-Token holen, da v3-Tokens nur 2 Minuten gültig sind
            und das Token vom Consent-Klick beim Absenden oft schon abgelaufen ist (timeout-or-duplicate) */
        if (window.grecaptcha && $("#ttgKatalogForm .google-recaptcha").length) {
            grecaptcha.execute($("#ttgKatalogForm").find('.google-recaptcha').data('sitekey'), {
                action: 'submitKatalog'
            }).then(function(token) {
                $('#ttgKatalogForm input[type="hidden"][name="g-recaptcha-response"]').val(token);
                $('#ttgKatalogForm').submit();
            }).catch(function() {
                /*  Fallback: mit altem Token absenden statt Formular hängen zu lassen */
                $('#ttgKatalogForm').submit();
            });
        } else {
            $('#ttgKatalogForm').submit();
        }

    }

});

$('.btnCatForm.showForm').click(function(e) {
    e.preventDefault();
    var padding = 100;
    if ($(window).width() < 992) {
        padding = 100; /*  zufällig gleich wie Desktop */
    }
    $("#ttgKatalogForm").animatescroll({
        'padding': padding
    });
});

/*  leere Eingabefeld wenn Standartwert */
$('#ttgKatalogForm input, #ttgKatalogForm textarea').focus(function() {
    if ($(this).val() == $(this).attr('title')) {
        $(this).val('');
    }
});

/*  fülle Eingabefeld mit Standartwert wenn keine Eingabe */
$('#ttgKatalogForm input, #ttgKatalogForm textarea').blur(function() {
    if (!$(this).val()) {
        $(this).val($(this).attr('title'));
    }
});

// $('.ttgKatalogeCategoryHeadline a').click(function() {
//     $(this).parent().next('ul').toggleClass('closed');
//     $(this).toggleClass('closed');
// });


/*  Check Fields */
function checkField(id) {

    var value = $('#' + id).val(); /*  aktueller Wert */
    var title = $('#' + id).attr('title'); /*  Standardwert */

    /*  Check ob Standardwert oder leer >> ERROR */
    if ((value == title) || !value) {
        $('#' + id).addClass('invalid');
    } else {

        /*  Spezieller Check für eMail Feld */
        if (id == "email") {

            /*  Check auf korrekte eMail-Adresse */
            var reg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (reg.test(value)) {
                $('#' + id).removeClass('invalid'); /*  eMail-Adresse korrekt */
            } else {
                $('#' + id).addClass('invalid'); /*  eMail-Adresse unkorrekt >> ERROR */
            }
        } else {

            $('#' + id).removeClass('invalid');
            if ($('#' + id).attr('id') == "anrede" || $('#' + id).attr('id') == "land") {
                $('#' + id).next().removeClass('invalid');
            }

        }

    }

}

/*  entferne gewählten Katalog */
function removeCat(id) {
    $('#' + id).trigger('click');
    $('#checked' + id).closest('.checkedCat').remove();
}
